export default __webpack_public_path__ + "static/media/ellipse_insta_prof.e992c34a.svg";